import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";
import { useTranslation } from "react-i18next";

interface ListsActionsProps {
  onCreateList: () => void;
}

export const ListsActions = ({
  onCreateList
}: ListsActionsProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex gap-2">
      <Button 
        onClick={onCreateList} 
        className="bg-[#5a7ebf] hover:bg-[#5a7ebf]/90"
      >
        <Plus className="h-4 w-4 mr-2" />
        {t("lists.create", "Create List")}
      </Button>
    </div>
  );
};
